<template>
  <AnimationComponent>
    <section class="relative max-sm:px-6 max-xl:px-13">
      <!-- Background pattern would go here if needed -->

      <div class="flex flex-col gap-12 md:gap-16 items-center pt-12 md:pt-24 pb-0 px-0">
        <!-- Content Container -->
        <div class="flex flex-col gap-0 items-center max-w-content py-0 w-full">
          <div class="flex flex-col gap-8 md:gap-12 items-center w-full">
            <!-- Heading and Text -->
            <div class="flex flex-col gap-6 items-center max-w-content w-full">
              <div class="flex flex-col gap-4 items-center w-full">
                <h1
                  class="text-4xl md:text-7xl font-semibold leading-11 md:leading-[90px] text-base-white text-center tracking-tight md:tracking-tight w-full"
                >
                  Grow your business with simple, smart payment solutions
                </h1>
              </div>
              <p
                class="text-base md:text-xl font-normal leading-6 md:leading-[30px] max-w-3xl text-grey-dark-300 text-center w-full"
              >
                Leading brands use LayUp to centralise, digitise, and automate in-store recurring payments to increase
                incremental revenue.
              </p>
            </div>

            <!-- Action Buttons -->
            <div class="flex flex-col md:flex-row gap-4 md:gap-3 items-stretch md:items-start w-full md:w-auto">
              <router-link :to="{ name: 'business-enquiry' }">
                <Button variant="outline-light" size="business" class="text-lg w-full md:w-auto">Talk to sales</Button>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Hero Image Container -->
        <div class="flex flex-col items-center overflow-hidden py-0 w-full max-w-content">
          <div class="border-4 border-brand-700 rounded-4xl h-[305px] md:h-[590px] w-full relative overflow-hidden">
            <img
              :src="heroImage"
              fetchpriority="high"
              alt="LayUp Payment Solution"
              class="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  </AnimationComponent>
</template>

<script setup lang="ts">
import heroImage from '@/assets/images/business/hero-image.jpg';
import AnimationComponent from '@/components/AnimationComponent.vue';
import { Button } from '@/components/ui/button';
</script>
